import { useMediaQuery } from "./useMediaQuery";
export var useIsMobile = function () { return useMediaQuery('(max-width: 786px)'); };
